// Mock data for Enersider — energy media platform.
// Content adapted & summarised from Enersider's real coverage of India's energy sector.

export const logoUrl = 'https://customer-assets-lqy194kg.emergentagent.net/job_enersider-revamp/artifacts/tz9vami1_image.png';

export const topics = [
  { slug: 'renewables', name: 'Renewables', blurb: 'Solar, wind and the march to 500 GW.' },
  { slug: 'green-hydrogen', name: 'Green Hydrogen', blurb: 'From policy frameworks to pilot plants.' },
  { slug: 'natural-gas', name: 'Natural Gas & LNG', blurb: 'India’s transition fuel and its infrastructure push.' },
  { slug: 'power-grid', name: 'Power & Grid', blurb: 'Capacity, transmission and state roadmaps.' },
  { slug: 'energy-storage', name: 'Energy Storage', blurb: 'BESS, FDRE and firm renewable power.' },
  { slug: 'bioenergy', name: 'Bioenergy', blurb: 'Biogas, biomass and waste-to-energy.' },
  { slug: 'policy', name: 'Policy & Climate', blurb: 'Tenders, targets and the net-zero pathway.' },
];

export const articles = [
  {
    id: 1,
    slug: 'karnataka-66gw-roadmap',
    title: 'Karnataka Charts a Path From 39 GW to 66 GW by 2030',
    excerpt: 'The state has laid out a decade-long roadmap to nearly double its installed power capacity — a blueprint many others may follow.',
    category: 'Power & Grid',
    image: 'https://images.unsplash.com/photo-1644567103258-6da3857faab4',
    author: 'Enersider Desk',
    role: 'Power & Policy',
    date: 'Dec 18, 2025',
    readTime: '7 min read',
    featured: true,
    body: [
      'Karnataka has set out a ten-year roadmap to expand its installed power capacity from around 39 GW today to 66 GW by 2030, according to the state’s energy department leadership.',
      'The plan leans heavily on renewables paired with storage, positioning the state as a testbed for how India scales clean capacity while keeping the grid firm and dispatchable.',
      'For developers, the signal is clear: the next wave of growth will reward projects that can deliver power on demand, not just when the sun shines or the wind blows.',
      'The roadmap also raises the familiar questions of transmission readiness, land, and the pace of clearances — the practical constraints that decide whether ambitious targets become megawatts on the ground.',
    ],
  },
  {
    id: 2,
    slug: 'fdre-storage-tenders',
    title: 'India Pivots From Plain Solar to Firm, Dispatchable Renewables',
    excerpt: 'Agencies like SECI, NTPC, NHPC and SJVN have been directed to favour clean projects bundled with storage to meet peak demand.',
    category: 'Energy Storage',
    image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276',
    author: 'Enersider Desk',
    role: 'Policy & Markets',
    date: 'Dec 14, 2025',
    readTime: '6 min read',
    featured: true,
    body: [
      'India’s procurement is shifting decisively. Central implementing agencies have been asked to prioritise Firm and Dispatchable Renewable Energy (FDRE) configurations over standalone solar tenders.',
      'The intent is to solve the peak-demand problem: renewables paired with batteries that can deliver reliable, round-the-clock power rather than intermittent generation.',
      'Investment in the renewable sector has climbed sharply, underlining that storage is no longer an add-on but the centre of the next tender cycle.',
    ],
  },
  {
    id: 3,
    slug: 'adani-green-hydrogen-kutch',
    title: 'Green Hydrogen Moves From Policy to Plant in Kutch',
    excerpt: 'A 5 MW off-grid green hydrogen pilot marks the sector’s shift from frameworks to real, pilot-scale execution.',
    category: 'Green Hydrogen',
    image: 'https://images.pexels.com/photos/38305355/pexels-photo-38305355.jpeg',
    author: 'Enersider Desk',
    role: 'Clean Fuels',
    date: 'Dec 09, 2025',
    readTime: '5 min read',
    featured: false,
    body: [
      'India’s green hydrogen story is entering a new phase — from policy documents to steel in the ground. A newly commissioned 5 MW off-grid pilot plant in Kutch is a marker of that transition.',
      'Pilot-scale execution matters because it surfaces the real engineering and cost questions that slide decks tend to skip: water, power supply, and the economics of the electrolyser.',
      'With recent tenders showing green hydrogen prices easing toward the mid-USD-4-per-kilogram range, the competitiveness gap is narrowing faster than many expected.',
    ],
  },
  {
    id: 4,
    slug: 'mngl-lng-lcng-nashik',
    title: 'Natural Gas Infrastructure Deepens With a New LNG-LCNG Station in Nashik',
    excerpt: 'A major station in Pathardi now supplies over 2 lakh SCMD, underscoring gas’s role as India’s transition fuel.',
    category: 'Natural Gas & LNG',
    image: 'https://images.unsplash.com/photo-1509390288171-ce2088f7d08e',
    author: 'Enersider Desk',
    role: 'Gas & Infrastructure',
    date: 'Dec 04, 2025',
    readTime: '5 min read',
    featured: false,
    body: [
      'Natural gas continues to anchor India’s energy transition, and the infrastructure to move it is quietly expanding.',
      'A newly operational LNG-LCNG station in Pathardi, Nashik is supplying more than 2 lakh standard cubic metres a day — a concrete step in extending gas access across the region.',
      'As the debate over gas’s long-term role continues, buildout like this shapes how quickly industry and mobility can switch away from dirtier fuels today.',
    ],
  },
  {
    id: 5,
    slug: 'kp-group-korea-hydrogen',
    title: 'Indian Developers Court Global Partners to Build a Hydrogen Ecosystem',
    excerpt: 'Cross-border pacts — including tie-ups with South Korean provinces — aim to accelerate India’s green hydrogen ambitions.',
    category: 'Green Hydrogen',
    image: 'https://images.unsplash.com/photo-1466611653911-95081537e5b7',
    author: 'Enersider Desk',
    role: 'Clean Fuels',
    date: 'Nov 28, 2025',
    readTime: '6 min read',
    featured: false,
    body: [
      'Building a hydrogen ecosystem is a team sport, and Indian developers are increasingly looking abroad for technology, offtake and capital.',
      'Recent partnerships — including collaboration with South Korea’s Jeonbuk Province — point to a strategy of importing know-how while scaling domestic capacity.',
      'The prize is a home-grown value chain for a fuel that could decarbonise the sectors electrons alone cannot reach.',
    ],
  },
  {
    id: 6,
    slug: 'advait-greenergy-integrated',
    title: 'The Rise of Integrated Clean-Energy Platforms',
    excerpt: 'Companies are expanding across BESS, solar EPC and hydrogen to support India’s 500 GW non-fossil target by 2030.',
    category: 'Renewables',
    image: 'https://images.unsplash.com/photo-1619641805634-b867f535071c',
    author: 'Enersider Desk',
    role: 'Corporate',
    date: 'Nov 21, 2025',
    readTime: '5 min read',
    featured: false,
    body: [
      'A new kind of energy company is emerging in India — one that refuses to pick a single lane.',
      'By expanding across battery storage, solar EPC and hydrogen infrastructure, integrated platforms are betting that the transition rewards breadth as much as depth.',
      'It is a strategy built around a single national number: the 500 GW of non-fossil capacity India aims to reach by 2030.',
    ],
  },
  {
    id: 7,
    slug: 'clean-energy-investment-surge',
    title: 'Clean-Energy Investment Surges as Storage Takes Centre Stage',
    excerpt: 'Capital flowing into renewables has jumped, with firm power and batteries reshaping where the money goes.',
    category: 'Policy & Climate',
    image: 'https://images.unsplash.com/photo-1508514177221-188b1cf16e9d',
    author: 'Enersider Desk',
    role: 'Markets',
    date: 'Nov 14, 2025',
    readTime: '6 min read',
    featured: false,
    body: [
      'The money is following the megawatts — and increasingly, the megawatt-hours.',
      'Investment in India’s renewable sector has risen sharply, with a growing share directed at storage and firm-power configurations rather than plain generation.',
      'That shift in capital allocation is quietly rewriting the risk profile of the entire sector.',
    ],
  },
  {
    id: 8,
    slug: 'bioenergy-hard-to-abate',
    title: 'Bioenergy’s Quiet Role in Decarbonising the Hard-to-Abate',
    excerpt: 'Biogas, biomass and waste-to-energy are gaining ground where electrification struggles to reach.',
    category: 'Bioenergy',
    image: 'https://images.pexels.com/photos/210267/pexels-photo-210267.jpeg',
    author: 'Enersider Desk',
    role: 'Bioenergy',
    date: 'Nov 07, 2025',
    readTime: '5 min read',
    featured: false,
    body: [
      'Not every sector can be electrified, and that is where bioenergy earns its place in the transition.',
      'Biogas, biomass and waste-to-energy offer pragmatic pathways for the hard-to-abate corners of the economy — and a route to value from waste streams.',
      'Industry bodies are pushing for the policy clarity that would turn a patchwork of projects into a genuine national opportunity.',
    ],
  },
];

export const currentEdition = {
  month: 'December 2025',
  title: 'The Capacity Issue',
  cover: 'https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?crop=entropy&cs=srgb&fm=jpg&q=85',
  highlights: [
    'Karnataka’s roadmap from 39 GW to 66 GW by 2030',
    'The pivot to firm, dispatchable renewables',
    'Green hydrogen: from policy to pilot plants',
    'Natural gas infrastructure deepens across states',
  ],
};

export const events = [
  {
    id: 1,
    title: 'Enersider Annual Business Conclave',
    date: 'Feb 20, 2026',
    location: 'New Delhi, India',
    type: 'Conclave',
    image: 'https://images.unsplash.com/photo-1769798643655-e0f10f62c3fd?crop=entropy&cs=srgb&fm=jpg&q=85',
    description: 'Our flagship gathering spotlighting sustainable energy innovation across India — bringing policymakers, developers and financiers to one table.',
  },
  {
    id: 2,
    title: 'Green Hydrogen & Net Zero Dialogue',
    date: 'Mar 18, 2026',
    location: 'Mumbai, India',
    type: 'Dialogue',
    image: 'https://images.unsplash.com/photo-1769798643630-194a0fcfa367?crop=entropy&cs=srgb&fm=jpg&q=85',
    description: 'In partnership with GH2 India — aligning policy and industry on the pathway to bankable green hydrogen at scale.',
  },
  {
    id: 3,
    title: 'The Natural Gas Dialogue',
    date: 'Apr 09, 2026',
    location: 'Ahmedabad, India',
    type: 'Roundtable',
    image: 'https://images.unsplash.com/photo-1735679356705-7c06b780c7a4?crop=entropy&cs=srgb&fm=jpg&q=85',
    description: 'With the Natural Gas Society — a candid roundtable on gas as India’s transition fuel amid a rapid infrastructure buildout.',
  },
];

export const clubImage = 'https://images.unsplash.com/photo-1563461661026-49631dd5d68e?crop=entropy&cs=srgb&fm=jpg&q=85';
export const clubImage2 = 'https://images.pexels.com/photos/8761650/pexels-photo-8761650.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';

export const stats = [
  { value: '50+', label: 'Monthly editions published' },
  { value: '120k+', label: 'Energy leaders reached' },
  { value: '30+', label: 'Dialogues & conclaves hosted' },
  { value: '4', label: 'Global editorial bureaus' },
];

export const partners = [
  'NETRA', 'GH2 India', 'Natural Gas Society', 'Indian Biogas Association',
  'Carbon Markets Association of India', 'Net Zero Energy Transition', 'SECI', 'Storage Coalition',
];

export const newsWire = [
  { headline: 'Cabinet clears incentive push for domestic solar cell manufacturing', source: 'PIB', time: '2h ago' },
  { headline: 'India adds record renewable capacity in the last quarter, data shows', source: 'PTI', time: '4h ago' },
  { headline: 'Green hydrogen mission gets fresh allocation for pilot projects', source: 'ANI', time: '6h ago' },
  { headline: 'Grid operator flags peak-demand records as summer approaches', source: 'PTI', time: '9h ago' },
  { headline: 'New city gas distribution licences awarded across three states', source: 'PIB', time: '12h ago' },
  { headline: 'Battery storage tenders oversubscribed as developers rush in', source: 'ANI', time: '1d ago' },
];

export const heroImage = 'https://images.unsplash.com/photo-1466611653911-95081537e5b7?crop=entropy&cs=srgb&fm=jpg&q=85';

// ---- Magazine structured sections ----
export const digitalEditionUrl = 'https://enersidermedia.com/edition-september-2026/';

export const coverStory = {
  edition: 'September 2026 Edition',
  eyebrow: 'Cover Story · Editorial',
  title: 'The Firm-Power Decade',
  dek: 'India\u2019s energy transition is entering a new phase \u2014 one measured not in gigawatts installed, but in gigawatts available on demand. Our editorial on the shift to firm, dispatchable renewables.',
  editor: 'Raymol Thomas',
  editorRole: 'Editor-in-Chief',
  image: 'https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?crop=entropy&cs=srgb&fm=jpg&q=85',
  body: [
    'For a decade, India\u2019s clean-energy story was told in the language of capacity added. The next decade will be told in the language of reliability delivered.',
    'The pivot from plain solar to firm and dispatchable renewable energy is more than a procurement footnote \u2014 it is a re-architecting of how the country plans to keep the lights on as demand climbs and coal recedes.',
    'This edition maps that shift: the tenders rewarding storage, the states drafting capacity roadmaps, and the developers learning that the value now lies in when you can deliver power, not just how much.',
  ],
};

export const authoredArticles = [
  { id: 'a1', slug: 'karnataka-66gw-roadmap', title: 'Karnataka Charts a Path From 39 GW to 66 GW by 2030', author: 'Ananya Rao', role: 'Senior Correspondent', category: 'Power & Grid', readTime: '7 min', image: 'https://images.unsplash.com/photo-1644567103258-6da3857faab4', excerpt: 'A decade-long roadmap to nearly double installed capacity \u2014 a blueprint others may follow.' },
  { id: 'a2', slug: 'fdre-storage-tenders', title: 'India Pivots From Plain Solar to Firm, Dispatchable Renewables', author: 'Marcus Lindqvist', role: 'Markets Analyst', category: 'Energy Storage', readTime: '6 min', image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276', excerpt: 'Agencies are being asked to favour clean projects bundled with storage to meet peak demand.' },
  { id: 'a3', slug: 'adani-green-hydrogen-kutch', title: 'Green Hydrogen Moves From Policy to Plant in Kutch', author: 'Sofia Mar\u00edn', role: 'Contributing Editor', category: 'Green Hydrogen', readTime: '5 min', image: 'https://images.pexels.com/photos/38305355/pexels-photo-38305355.jpeg', excerpt: 'A 5 MW off-grid pilot marks the sector\u2019s shift from frameworks to real execution.' },
  { id: 'a4', slug: 'advait-greenergy-integrated', title: 'The Rise of Integrated Clean-Energy Platforms', author: 'Ananya Rao', role: 'Senior Correspondent', category: 'Renewables', readTime: '5 min', image: 'https://images.unsplash.com/photo-1619641805634-b867f535071c', excerpt: 'Firms expanding across BESS, solar EPC and hydrogen to support the 500 GW target.' },
  { id: 'a5', slug: 'bioenergy-hard-to-abate', title: 'Bioenergy\u2019s Quiet Role in Decarbonising the Hard-to-Abate', author: 'Sofia Mar\u00edn', role: 'Contributing Editor', category: 'Bioenergy', readTime: '5 min', image: 'https://images.pexels.com/photos/210267/pexels-photo-210267.jpeg', excerpt: 'Biogas, biomass and waste-to-energy gain ground where electrification struggles.' },
];

export const spotlights = [
  { org: 'GH2 India', full: 'Green Hydrogen Association', blurb: 'Advancing India\u2019s green hydrogen ecosystem from policy to bankable projects.', accent: '#0E9F6E' },
  { org: 'CRF', full: 'Chintan Research Foundation', blurb: 'Independent research shaping the discourse on energy, climate and policy.', accent: '#2563EB' },
  { org: 'NETRA', full: 'Net Zero Energy Transition Association', blurb: 'Convening stakeholders around a credible, just net-zero pathway.', accent: '#D01919' },
  { org: 'IBA', full: 'Indian Biogas Association', blurb: 'Championing biogas and waste-to-energy across the country.', accent: '#B45309' },
];

export const whatMadeNews = [
  { headline: 'Cabinet clears incentive push for domestic solar cell manufacturing', tag: 'Policy' },
  { headline: 'Record renewable capacity added in the last quarter, official data shows', tag: 'Renewables' },
  { headline: 'Green hydrogen mission gets fresh allocation for pilot projects', tag: 'Hydrogen' },
  { headline: 'City gas distribution licences awarded across three new states', tag: 'Gas' },
  { headline: 'Battery storage tenders oversubscribed as developers rush in', tag: 'Storage' },
  { headline: 'Grid operator flags fresh peak-demand records ahead of summer', tag: 'Power' },
];

export const industryReport = {
  eyebrow: 'Industry Report',
  title: 'India\u2019s Storage Inflection: Inside the FDRE Decade',
  summary: 'Our data-led deep dive into how firm, dispatchable renewables are reshaping tenders, tariffs and the economics of the grid.',
  image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85',
  stats: [
    { value: '66 GW', label: 'Targeted state capacity by 2030' },
    { value: '500 GW', label: 'National non-fossil goal' },
    { value: '~$4.4', label: 'Green H\u2082 tender price / kg' },
  ],
};

export const enersiderBrief = {
  eyebrow: 'Enersider Brief',
  title: 'This month, in five lines',
  points: [
    'Firm, dispatchable renewables move from concept to default in central tenders.',
    'Green hydrogen crosses from policy frameworks into pilot-scale plants.',
    'Natural gas infrastructure keeps expanding as a near-term transition fuel.',
    'Integrated platforms bet that breadth beats specialisation this decade.',
    'Bioenergy finds its footing in the hard-to-abate corners of the economy.',
  ],
};

export const newsmaker = {
  eyebrow: 'Newsmaker of the Month',
  name: 'A. Menon',
  designation: 'Managing Director',
  org: 'National Renewables Corporation',
  image: 'https://images.pexels.com/photos/30692588/pexels-photo-30692588.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  quote: 'The winners of this decade won\u2019t be those who build the most capacity \u2014 they\u2019ll be those who deliver the most reliable power.',
  bio: 'For steering one of the country\u2019s largest firm-power portfolios through the shift to dispatchable renewables, our Newsmaker of the Month has become a defining voice of the FDRE era.',
};

export const featuredEditions = [
  { month: 'August 2026', title: 'The Grid Issue', image: 'https://images.unsplash.com/photo-1644567103258-6da3857faab4', teaser: 'Transmission, interconnection and the quiet revolution in the wires.' },
  { month: 'July 2026', title: 'The Molecule Issue', image: 'https://images.pexels.com/photos/38305355/pexels-photo-38305355.jpeg', teaser: 'Green hydrogen\u2019s journey from hype to gigawatts.' },
  { month: 'June 2026', title: 'The Storage Issue', image: 'https://images.unsplash.com/photo-1619641805634-b867f535071c', teaser: 'Batteries, BESS and the multi-day gap renewables must fill.' },
];

export const upcomingCoverStories = [
  { month: 'October 2026', title: 'The Transmission Crunch', teaser: 'Why the grid \u2014 not generation \u2014 is the real bottleneck.' },
  { month: 'November 2026', title: 'The Hydrogen Economy', teaser: 'Offtake, exports and the molecules that will actually move.' },
  { month: 'December 2026', title: 'Year in Energy 2026', teaser: 'The people, projects and policies that defined the year.' },
];

// ---- Podcasts (Enersider YouTube channel) ----
export const podcasts = [
  { id: 'dznzvbfg_jM', title: 'The Enersider Podcast \u2014 The Firm-Power Conversation', guest: 'Industry leaders in conversation', description: 'A candid discussion on the shift to firm, dispatchable renewables and what it means for India\u2019s grid.' },
  { id: 'fGvdNtv3GWI', title: 'The Enersider Podcast \u2014 Green Hydrogen, Real Projects', guest: 'Clean fuels special', description: 'From policy to pilot plants \u2014 unpacking where green hydrogen is finally getting built.' },
  { id: '372CW77_mjo', title: 'The Enersider Podcast \u2014 Financing the Transition', guest: 'Capital & markets edition', description: 'How capital is flowing into storage, renewables and the infrastructure of the transition.' },
];

// ---- Events: three tracks ----
export const eventsData = {
  conclave: {
    name: 'Annual Business Conclave',
    tagline: 'Enersider\u2019s flagship gathering of the energy sector',
    date: 'February 20, 2026',
    location: 'New Delhi, India',
    image: 'https://images.unsplash.com/photo-1769798643655-e0f10f62c3fd?crop=entropy&cs=srgb&fm=jpg&q=85',
    description: 'A full day of keynotes, panels and closed-door dialogue \u2014 bringing policymakers, developers, financiers and technology leaders to one table to spotlight sustainable energy innovation across India.',
    stats: [
      { value: '600+', label: 'Delegates' },
      { value: '40+', label: 'Speakers' },
      { value: '12', label: 'Sessions' },
    ],
  },
  felas: {
    name: 'FELAS',
    full: 'Future Energy Leadership & Achievement Awards',
    tagline: 'Honouring the changemakers of the energy transition',
    date: 'May 2026',
    location: 'Mumbai, India',
    image: 'https://images.unsplash.com/photo-1650240852447-46505dba4726?crop=entropy&cs=srgb&fm=jpg&q=85',
    description: 'FELAS celebrates the projects, companies and individuals driving India\u2019s clean-energy future \u2014 recognised across renewables, storage, hydrogen, gas and sustainability leadership.',
    categories: ['Renewable Project of the Year', 'Storage Innovation', 'Green Hydrogen Pioneer', 'Sustainability Leadership', 'Newsmaker of the Year'],
  },
  partners: [
    { title: 'Green Hydrogen & Net Zero Dialogue', partner: 'in partnership with GH2 India', date: 'Mar 18, 2026', location: 'Mumbai', image: 'https://images.unsplash.com/photo-1769798643630-194a0fcfa367?crop=entropy&cs=srgb&fm=jpg&q=85' },
    { title: 'The Natural Gas Dialogue', partner: 'with the Natural Gas Society', date: 'Apr 09, 2026', location: 'Ahmedabad', image: 'https://images.unsplash.com/photo-1735679356705-7c06b780c7a4?crop=entropy&cs=srgb&fm=jpg&q=85' },
    { title: 'Bioenergy Roundtable', partner: 'with the Indian Biogas Association', date: 'Jun 12, 2026', location: 'Pune', image: 'https://images.pexels.com/photos/210267/pexels-photo-210267.jpeg' },
  ],
};
